import type { Question } from "./types";
import { isAnswered, isCorrect } from "./grading";
import { showRightAnswer, showWrongAnswer } from "./feedback";
import { incrementAttempts } from "./storage";

const POINTS_TOTAL = 100;

function isFormValid(questions: Question[]): boolean {
  const validationFdbk = document.querySelector("#validationFdbk")!;
  const unanswered = questions
    .filter((question) => !isAnswered(question))
    .map((question) => question.id);

  if (unanswered.length > 0) {
    validationFdbk.textContent = `Please answer question(s): ${unanswered.join(", ")}`;
    validationFdbk.className = "alert alert-danger mt-3";
    return false;
  }

  validationFdbk.textContent = "";
  validationFdbk.className = "";
  return true;
}

export function gradeQuiz(questions: Question[]): void {
  if (!isFormValid(questions)) {
    return;
  }

  let score = 0;
  const pointsPerQuestion = POINTS_TOTAL / questions.length;

  for (const question of questions) {
    if (isCorrect(question)) {
      showRightAnswer(question.id);
      score += pointsPerQuestion;
    } else {
      showWrongAnswer(question.id);
    }
  }

  const totalScore = document.querySelector("#totalScore")!;
  const scoreFeedback = document.querySelector("#scoreFeedback")!;

  totalScore.textContent = `Total Score: ${score} / ${POINTS_TOTAL}`;

  if (score < 80) {
    totalScore.className = "h2 mt-3 text-danger";
    scoreFeedback.textContent = "Please try again!";
    scoreFeedback.className = "h3 text-danger";
  } else {
    totalScore.className = "h2 mt-3 text-success";
    scoreFeedback.textContent = "🎉 Congratulations! You passed the quiz!";
    scoreFeedback.className = "h3 text-success";
  }

  const attempts = incrementAttempts();
  document.querySelector("#totalAttempts")!.textContent =
    `Total Times the quiz was taken: ${attempts}`;
}
